import React, {
  useState,
  useMemo,
  useRef,
  useCallback,
  useEffect,
} from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
// import "ag-grid-community/styles/ag-theme-alpine.css";
import { NavLink } from "react-router-dom";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { sweetAlert } from "../../Common/Utills/Utills";
import moment from "moment";
import UpdateStaffSalary from "./UpdateStaffSalary";
import AddStaffSalary from "./AddStaffSalary";
import Pagination from "../../Common/Pagination/Pagination";
import _ from "lodash";
const StaffSalary = () => {
  const [selectedRows, setSelectedRows] = useState([]);
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const [rmvBtn, setRmvBtn] = useState(false);
  const [rowData, setRowData] = useState([]);
  const gridRef = useRef();
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [selectedRowsData, setselectedRowsData] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [showSearch, setShowSearch] = useState(false);
  const totalPages = Math.ceil(totalRecords / pageSize);
  const startItem = (currentPage - 1) * pageSize + 1;
  const endItem = Math?.min(startItem + rowData?.length - 1, totalRecords);
  const [company, setCompany] = useState([]);
  const [selectedCompanyId, setSelectedCompanyId] = useState("");
  const [staff, setStaff] = useState([]);
  const [personName, setPersonName] = useState("");

  // console.log("rowData", rowAddData)

  const onPageChange = (newPage) => {
    setCurrentPage(newPage);
    gridRef.current.api.showLoadingOverlay();
  };

  const onPageSizeChange = (event) => {
    setPageSize(parseInt(event.target.value));
    gridRef.current.api.showLoadingOverlay();
    setCurrentPage(1); // Reset to the first page when page size changes
  };
  const [filterCriteria, setfilterCriteria] = useState({
    company_id: "",
    staff_id: "",
    date: "",
  });

  const updateHandleChange = (e) => {
    if (e.target) {
      const { name, value } = e.target;
      setselectedRowsData(() => {
        return {
          ...selectedRowsData,
          [name]: value,
        };
      });
    } else {
      console.error("Event or event.target is undefined");
    }
  };

  const handleFilterChange = (name, value) => {
    setfilterCriteria(() => {
      return {
        ...setfilterCriteria,
        [name]: value,
      };
    });
  };

  const getData = async () => {
    let BASE_URL = SERVER_URL + `/api/staff-salary/all-staff-salary/${user_id}`;
    const nonEmptyFilterCriteria = Object.fromEntries(
      Object.entries(filterCriteria).filter(
        ([key, value]) => value !== null && value !== undefined && value !== ""
      )
    );

    const options = {
      whereFilters: nonEmptyFilterCriteria,
      skip: currentPage,
      take: pageSize,
    };
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(options),
    });
    const result = await res.json();
    if (res.ok) {
      setTotalRecords(result.total);
      setRowData(
        result.data.map((item, index) => {
          return {
            ...item,
            date: moment.utc(item.date).format("YYYY-MM-DD").toString(),
          };
        })
      );

      // Check if gridRef is defined and has the api property before using it
      if (gridRef.current && gridRef.current.api) {
        gridRef.current.api.hideOverlay();
      }
    } else {
      setRowData([]);
    }
  };

  let check = true;
  const [loadingOverlayVisible, setLoadingOverlayVisible] = useState(false);
  useEffect(() => {
    if (check) {
      if (loadingOverlayVisible) {
        if (gridRef.current && gridRef.current.api) {
          gridRef.current.api.showLoadingOverlay();
        }
      }
      setLoadingOverlayVisible(true);
      const fecthDebounced = _.debounce(getData, 500);
      fecthDebounced();
      return () => {
        fecthDebounced.cancel();
      };
    }
    check = false;
  }, [currentPage, pageSize, filterCriteria]);

  useEffect(() => {
    setCurrentPage(1);
  }, [filterCriteria]);

  // const addData = (newData) => {
  //   console.log("Adding data:", newData);
  //   setRowData((prevData) => [...prevData, newData]);
  // };

  const onCellValueChanged = (params) => {
    const updatedData = params.data;
    updateData(updatedData);
    // setRowData((prevData) =>
    //   prevData.map((row) => (row === params.data ? updatedData : row))
    // );
    // console.log("Updated data:", updatedData);
  };

  const onSelectionChanged = useCallback((event) => {
    const selectedNodes = event.api.getSelectedNodes();
    if (selectedNodes?.length > 1) {
      setRmvBtn(true);
    }
    if (selectedNodes?.length < 2) {
      setRmvBtn(false);
    }
    const selectedData = selectedNodes.map((node) => node.data);
    setSelectedRows(selectedData);
    // window.alert("selection changed, " + rowCount + " rows selected");
  }, []);

  const deleteSelectedRows = () => {
    setRowData((prevData) =>
      prevData.filter((row) => !selectedRows.includes(row))
    );
    // Clear the selection after deletion
    setSelectedRows([]);
  };

  const deleteRow = async (id) => {
    // setRowData((prevData) => prevData.filter((row) => row !== rowData));
    const message = "Do you want to delete this salary details!";

    const result = await sweetAlert(message);

    if (!result.isConfirmed) {
      return;
    }

    let BASE_URL = SERVER_URL + `/api/staff-salary/staff-salary/${user_id}`;

    const res = await fetch(BASE_URL, {
      method: "DELETE",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
      }),
    });
    const response = await res.json();
    if (res.ok) {
      setTimeout(() => {
        toast.success(response.message);
        // navigate("/dashboard");
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
      getData();
      setfilterCriteria((prevFilterCriteria) => {
        return {
          ...prevFilterCriteria,
          // Retain the existing filter criteria values
        };
      });
    }
  };

  const addDataToModal = async (rowData) => {
    setselectedRowsData(rowData);
  };
  const updateData = async (rowData) => {
    const {
      id,
      company_id,
      date,
      staff_name,
      attendance,
      basic,
      da,
      salary,
      net_salary,
      advance,
      amount,
    } = rowData;
    let BASE_URL = SERVER_URL + `/api/staff-salary/staff-salary/${user_id}`;

    const res = await fetch(BASE_URL, {
      method: "PUT",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
        company_id,
        date,
        staff_name,
        attendance,
        basic,
        da,
        salary,
        net_salary,
        advance,
        amount,
      }),
    });
    const response = await res.json();
    if (res.ok) {
      setTimeout(() => {
        toast.success(response.message);
        // navigate("/dashboard");
      }, 1000);
      // getData();
    } else {
      toast.error(response.message);
      // getData();
    }
  };
  const [colDefs, setColDefs] = useState([
    {
      headerName: "S. No",
      valueGetter: (params) => params.node.rowIndex + 1,
      width: 100,
      minWidth: 100,
    },
    {
      headerName: "Company Name",
      field: "companyDetails.company_name",
      valueFormatter: (params) => {
        const location = params.data.companyDetails.location;
        return `${params.value}, ${location}`;
      },
      editable: true,
      width: 200,
      minWidth: 200,
    },
    {
      headerName: "Date",
      field: "date",
      editable: true,
      width: 150,
      minWidth: 150,
    },
    {
      headerName: "Name",
      field: "staffName.staff_name",
      editable: true,
      width: 150,
      minWidth: 150,
    },
    {
      headerName: "Attendance",
      field: "attendance",
      editable: true,
      width: 150,
      minWidth: 150,
    },
    {
      headerName: "Basic",
      field: "basic",
      editable: false,
      width: 150,
      minWidth: 150,
    },
    {
      headerName: "DA",
      field: "da",
      editable: false,
      width: 150,
      minWidth: 150,
    },
    {
      headerName: "Salary",
      field: "salary",
      editable: true,
      width: 150,
      minWidth: 150,
    },
    // {
    //   headerName: "Net salary",
    //   field: "net_salary",
    //   editable: true,
    //   width: 150,
    //   minWidth: 150,
    // },
    {
      headerName: "Advance",
      field: "advance",
      editable: true,
      width: 150,
      minWidth: 150,
    },
    {
      headerName: "Amount",
      field: "amount",
      editable: true,
      width: 150,
      minWidth: 150,
    },
    {
      headerName: "Actions",
      cellRenderer: (params) => (
        <>
          <button
            className="btn btn-outline-danger btn-sm"
            onClick={() => deleteRow(params.data.id)}
          >
            <i className="mdi mdi-delete" />
          </button>{" "}
          <button
            className="btn btn-outline-secondary btn-sm"
            onClick={() => addDataToModal(params.data)}
            data-toggle="modal"
            data-target="#updateSalaryModal"
          >
            <i className="mdi mdi-note-edit-outline" />
          </button>
        </>
      ),
      minWidth: 205,
    },
  ]);

  const sortingOrder = useMemo(() => {
    return ["desc", "asc", null];
  }, []);
  const defaultColDef = useMemo(() => ({
    filter: true,
    editable: true,
    flex: 1,
    headerPosition: "sticky",
  }));
  const gridOptions = useMemo(
    () => ({
      rowSelection: "multiple",
      suppressRowClickSelection: true,
      suppressCellSelection: true,
    }),
    []
  );
  const onBtnExport = useCallback(() => {
    gridRef.current.api.exportDataAsCsv();
  }, []);

  const handleRefreshClick = () => {
    gridRef.current.api.showLoadingOverlay();
    getData();
    setfilterCriteria({
      company_id: "",
      staff_id: "",
      date: "",
    });
    setSelectedCompanyId("");
    setPersonName("");
  };

  const onGridReady = useCallback((params) => {
    params.api.showLoadingOverlay();
  });

  const getCompany = async () => {
    const BASE_URL = SERVER_URL + `/api/company/all-company-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    // console.log(result.data)
    setCompany(result.data);
  };

  useEffect(() => {
    getCompany();
  }, []);

  const handleCompanyChange = (e) => {
    const companyId = e.target.value != "" ? parseInt(e.target.value) : "";
    setSelectedCompanyId(companyId);
    setPersonName("");

    // Update filterCriteria with the selected company's ID
    setfilterCriteria((prevFilterCriteria) => ({
      ...prevFilterCriteria,
      company_id: companyId,
    }));
  };

  const getStaff = async () => {
    const BASE_URL =
      SERVER_URL +
      `/api/staff-detials/drop-staffDetails/${user_id}?company_id=${selectedCompanyId}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    setStaff(result.data);
  };

  useEffect(() => {
    if (selectedCompanyId) {
      getStaff();
    }
  }, [selectedCompanyId]);

  const handleOfficeUtils = (e) => {
    const staffId = e.target.value != "" ? parseInt(e.target.value) : "";
    setPersonName(staffId);

    setfilterCriteria((prevData) => ({
      ...prevData,
      staff_id: staffId,
    }));
  };
  return (
    <>
      <div className="card">
        <div className="card-body">
          <div className="card-title">
            Staff Salary Table &nbsp;
            <span>
              <button
                className="btn btn-sm btn-light btn-icon-text border"
                onClick={handleRefreshClick}
              >
                Refresh{" "}
                <i
                  className="mdi mdi-refresh"
                  style={{ height: "4px", width: "4px" }}
                ></i>{" "}
              </button>
            </span>
          </div>
          <div className="table_btn">
            <div className="mb-3">
              <button
                data-toggle="modal"
                data-target="#salaryModal"
                className="btn btn-outline-primary"
              >
                <span className="mr-1">
                  <i className="mdi mdi-briefcase-upload" />
                </span>
                Add Salary Details
              </button>
            </div>

            <div
              style={{
                marginBottom: "20px",
              }}
            >
              <button
                onClick={() => onBtnExport()}
                className="btn btn-outline-excel mr-1"
              >
                <span className="mr-1">
                  <i className="mdi mdi-file-export"></i>
                </span>
                Export to Excel
              </button>
            </div>
          </div>
          <div className="search mb-3">
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <select
                    className="form-control form-control-lg"
                    onChange={handleCompanyChange}
                    value={selectedCompanyId}
                  >
                    <option value="">Select Company (All)</option>
                    {company &&
                      company?.length > 0 &&
                      company?.map((item, id) => {
                        return (
                          <React.Fragment key={id}>
                            <option
                              value={item.id}
                              key={id}
                            >{`${item.company_name}, ${item.location}`}</option>
                          </React.Fragment>
                        );
                      })}
                  </select>
                </div>
              </div>
              {selectedCompanyId && (
                <div className="col-md-3">
                  <div className="form-group">
                    <select
                      className="form-control form-control-lg"
                      onChange={handleOfficeUtils}
                      value={personName}
                      required
                      id="Person"
                    >
                      <option value="">Select Person</option>
                      {staff &&
                        staff.length > 0 &&
                        staff.map((item, index) => {
                          return (
                            <option
                              key={index}
                              value={item.id}
                            >{`${item.staff_name}`}</option>
                          );
                        })}
                    </select>
                  </div>
                </div>
              )}
              <div className="col-md-3">
                <div className="form-group">
                  <input
                    type="date"
                    placeholder="Serch by mob number"
                    value={filterCriteria.date}
                    onChange={(e) => handleFilterChange("date", e.target.value)}
                    className="form-control"
                  />
                </div>
              </div>
            </div>
          </div>
          <div>
            <div
              className="ag-theme-quartz"
              style={{ width: "100%", height: 550 }}
            >
              <AgGridReact
                ref={gridRef}
                rowData={rowData}
                columnDefs={colDefs}
                defaultColDef={defaultColDef}
                // domLayout="autoHeight"
                headerHeight={40}
                rowHeight={50}
                sortingOrder={sortingOrder}
                enableCellTextSelection={true}
                context={{ currentPage, pageSize }}
                // gridOptions={gridOptions}
                rowSelection={"multiple"} // For row selection
                suppressRowClickSelection={true} // For row selection
                suppressCellSelection={true} // For row selection
                onGridReady={onGridReady}
                overlayLoadingTemplate={
                  '<span className="ag-overlay-loading-center">Please wait while your records are loading...</span>'
                }
                onCellValueChanged={onCellValueChanged}
                onSelectionChanged={onSelectionChanged}
              />
            </div>
          </div>
          <AddStaffSalary getData={getData} />
          <UpdateStaffSalary
            selectedRowsData={selectedRowsData}
            updateHandleChange={updateHandleChange}
            getData={getData}
            setselectedRowsData={setselectedRowsData}
          />
        </div>
        <Pagination
          currentPage={currentPage}
          totalRecords={totalRecords}
          pageSize={pageSize}
          totalPages={totalPages}
          startItem={startItem}
          endItem={endItem}
          onPageChange={onPageChange}
          onPageSizeChange={onPageSizeChange}
        />
      </div>
    </>
  );
};

export default StaffSalary;
